import SiteHeader, { type ActiveNav } from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";

interface LayoutProps {
  children: React.ReactNode;
  active?: ActiveNav;
  /** Backstop background for the page shell itself (above/around the sticky
   * header), so nothing can show through as the default white body background.
   * Pass the page's own hero color; omit to keep the default white shell
   * (used by pages that haven't been redesigned yet). */
  background?: string;
}

const Layout = ({ children, active = null, background }: LayoutProps) => {
  return (
    <div className="min-h-screen" style={background ? { background } : undefined}>
      <SiteHeader active={active} />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
};

export default Layout;
